import { useAppConfig } from '#/config/AppConfigContext';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { searchOrgsRoutePathByLocale } from '#/modules/search/orgs/routing/searchOrgs.route-paths';
import type { searchOrgsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { SearchOrgsPageLoadable } from './SearchOrgsPageLoadable';

export const handle = {
  urlByLocale: searchOrgsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'ORG',
  hideFooterDivider: true,
  showDesktopSearch: true,
  searchFromPageType: 'SEARCH',
  showSearchRefinements: true,
  isSearchPage: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchOrgsRouteReference>,
) {
  await SearchOrgsPageLoadable.load();
}

export default function SearchOrgsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { appConfig } = useAppConfig();
  const { i18n, locale } = useI18n();

  const ogImage = (() => {
    switch (locale) {
      case I18nLocale.EN:
        return getStaticImageSrc(
          'og-image-en-organizations.jpg',
          appConfig.idealist.staticImgPath,
        );
      case I18nLocale.ES:
        return;
      case I18nLocale.PT:
        return getStaticImageSrc(
          'og-image-pt-organizations.jpg',
          appConfig.idealist.staticImgPath,
        );
    }
  })();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: org search page title */
        i18n('Discover Nonprofits & Social-Impact Organizations')
      }
      ogImage={ogImage}
    >
      <SearchOrgsPageLoadable />
    </RouteModule>
  );
}
